/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * ScaleFi Nub APIs
 * Scale Fi Apis
 * OpenAPI spec version: v0.0.1
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AccountMappingDTO,
  AccountMappingType,
  MigrateAccountMappings200
} from '../model';

import { customInstance } from '../mutator/custom-instance';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getAccountMapping = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<AccountMappingDTO>(
      {url: `/api/account-mappings/${id}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetAccountMappingInfiniteQueryKey = (id?: number,) => {
    return [
    'infinite', `/api/account-mappings/${id}`
    ] as const;
    }

export const getGetAccountMappingQueryKey = (id?: number,) => {
    return [
    `/api/account-mappings/${id}`
    ] as const;
    }

    
export const getGetAccountMappingInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getAccountMapping>>>, TError = unknown>(id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAccountMapping>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAccountMappingInfiniteQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccountMapping>>> = ({ signal }) => getAccountMapping(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAccountMapping>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAccountMappingInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getAccountMapping>>>
export type GetAccountMappingInfiniteQueryError = unknown


export function useGetAccountMappingInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAccountMapping>>>, TError = unknown>(
 id: number, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAccountMapping>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccountMapping>>,
          TError,
          Awaited<ReturnType<typeof getAccountMapping>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAccountMappingInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAccountMapping>>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAccountMapping>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccountMapping>>,
          TError,
          Awaited<ReturnType<typeof getAccountMapping>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAccountMappingInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAccountMapping>>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAccountMapping>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAccountMappingInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAccountMapping>>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAccountMapping>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAccountMappingInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetAccountMappingQueryOptions = <TData = Awaited<ReturnType<typeof getAccountMapping>>, TError = unknown>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountMapping>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAccountMappingQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccountMapping>>> = ({ signal }) => getAccountMapping(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAccountMapping>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAccountMappingQueryResult = NonNullable<Awaited<ReturnType<typeof getAccountMapping>>>
export type GetAccountMappingQueryError = unknown


export function useGetAccountMapping<TData = Awaited<ReturnType<typeof getAccountMapping>>, TError = unknown>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountMapping>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccountMapping>>,
          TError,
          Awaited<ReturnType<typeof getAccountMapping>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAccountMapping<TData = Awaited<ReturnType<typeof getAccountMapping>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountMapping>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccountMapping>>,
          TError,
          Awaited<ReturnType<typeof getAccountMapping>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAccountMapping<TData = Awaited<ReturnType<typeof getAccountMapping>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountMapping>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAccountMapping<TData = Awaited<ReturnType<typeof getAccountMapping>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountMapping>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAccountMappingQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const updateAccountMapping = (
    id: number,
    accountMappingDTO: AccountMappingDTO,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<AccountMappingDTO>(
      {url: `/api/account-mappings/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: accountMappingDTO
    },
      options);
    }
  


export const getUpdateAccountMappingMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAccountMapping>>, TError,{id: number;data: AccountMappingDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAccountMapping>>, TError,{id: number;data: AccountMappingDTO}, TContext> => {

const mutationKey = ['updateAccountMapping'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAccountMapping>>, {id: number;data: AccountMappingDTO}> = (props) => {
          const {id,data} = props ?? {};

          return  updateAccountMapping(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateAccountMappingMutationResult = NonNullable<Awaited<ReturnType<typeof updateAccountMapping>>>
    export type UpdateAccountMappingMutationBody = AccountMappingDTO
    export type UpdateAccountMappingMutationError = unknown

    export const useUpdateAccountMapping = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAccountMapping>>, TError,{id: number;data: AccountMappingDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateAccountMapping>>,
        TError,
        {id: number;data: AccountMappingDTO},
        TContext
      > => {

      const mutationOptions = getUpdateAccountMappingMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const deleteAccountMapping = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/account-mappings/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteAccountMappingMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAccountMapping>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAccountMapping>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteAccountMapping'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAccountMapping>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteAccountMapping(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteAccountMappingMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAccountMapping>>>
    
    export type DeleteAccountMappingMutationError = unknown

    export const useDeleteAccountMapping = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAccountMapping>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteAccountMapping>>,
        TError,
        {id: number},
        TContext
      > => {

      const mutationOptions = getDeleteAccountMappingMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getAllAccountMappings = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<AccountMappingDTO[]>(
      {url: `/api/account-mappings`, method: 'GET', signal
    },
      options);
    }
  



export const getGetAllAccountMappingsInfiniteQueryKey = () => {
    return [
    'infinite', `/api/account-mappings`
    ] as const;
    }

export const getGetAllAccountMappingsQueryKey = () => {
    return [
    `/api/account-mappings`
    ] as const;
    }

    
export const getGetAllAccountMappingsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getAllAccountMappings>>>, TError = unknown>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllAccountMappings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllAccountMappingsInfiniteQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllAccountMappings>>> = ({ signal }) => getAllAccountMappings(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllAccountMappings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAllAccountMappingsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getAllAccountMappings>>>
export type GetAllAccountMappingsInfiniteQueryError = unknown


export function useGetAllAccountMappingsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllAccountMappings>>>, TError = unknown>(
  options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllAccountMappings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllAccountMappings>>,
          TError,
          Awaited<ReturnType<typeof getAllAccountMappings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllAccountMappingsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllAccountMappings>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllAccountMappings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllAccountMappings>>,
          TError,
          Awaited<ReturnType<typeof getAllAccountMappings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllAccountMappingsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllAccountMappings>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllAccountMappings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAllAccountMappingsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllAccountMappings>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllAccountMappings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAllAccountMappingsInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetAllAccountMappingsQueryOptions = <TData = Awaited<ReturnType<typeof getAllAccountMappings>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllAccountMappings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllAccountMappingsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllAccountMappings>>> = ({ signal }) => getAllAccountMappings(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllAccountMappings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAllAccountMappingsQueryResult = NonNullable<Awaited<ReturnType<typeof getAllAccountMappings>>>
export type GetAllAccountMappingsQueryError = unknown


export function useGetAllAccountMappings<TData = Awaited<ReturnType<typeof getAllAccountMappings>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllAccountMappings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllAccountMappings>>,
          TError,
          Awaited<ReturnType<typeof getAllAccountMappings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllAccountMappings<TData = Awaited<ReturnType<typeof getAllAccountMappings>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllAccountMappings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllAccountMappings>>,
          TError,
          Awaited<ReturnType<typeof getAllAccountMappings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllAccountMappings<TData = Awaited<ReturnType<typeof getAllAccountMappings>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllAccountMappings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAllAccountMappings<TData = Awaited<ReturnType<typeof getAllAccountMappings>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllAccountMappings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAllAccountMappingsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const createAccountMapping = (
    accountMappingDTO: AccountMappingDTO,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<AccountMappingDTO>(
      {url: `/api/account-mappings`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: accountMappingDTO, signal
    },
      options);
    }
  


export const getCreateAccountMappingMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAccountMapping>>, TError,{data: AccountMappingDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createAccountMapping>>, TError,{data: AccountMappingDTO}, TContext> => {

const mutationKey = ['createAccountMapping'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAccountMapping>>, {data: AccountMappingDTO}> = (props) => {
          const {data} = props ?? {};

          return  createAccountMapping(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateAccountMappingMutationResult = NonNullable<Awaited<ReturnType<typeof createAccountMapping>>>
    export type CreateAccountMappingMutationBody = AccountMappingDTO
    export type CreateAccountMappingMutationError = unknown

    export const useCreateAccountMapping = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAccountMapping>>, TError,{data: AccountMappingDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createAccountMapping>>,
        TError,
        {data: AccountMappingDTO},
        TContext
      > => {

      const mutationOptions = getCreateAccountMappingMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const migrateAccountMappings = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<MigrateAccountMappings200>(
      {url: `/api/account-mappings/migrate`, method: 'POST', signal
    },
      options);
    }
  


export const getMigrateAccountMappingsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof migrateAccountMappings>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof migrateAccountMappings>>, TError,void, TContext> => {

const mutationKey = ['migrateAccountMappings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof migrateAccountMappings>>, void> = () => {
          

          return  migrateAccountMappings(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type MigrateAccountMappingsMutationResult = NonNullable<Awaited<ReturnType<typeof migrateAccountMappings>>>
    
    export type MigrateAccountMappingsMutationError = unknown

    export const useMigrateAccountMappings = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof migrateAccountMappings>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof migrateAccountMappings>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getMigrateAccountMappingsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getAllAccountMappingsByProductPropertiesGlNo = (
    glNo: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<AccountMappingDTO[]>(
      {url: `/api/account-mappings/product-properties/${glNo}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetAllAccountMappingsByProductPropertiesGlNoInfiniteQueryKey = (glNo?: string,) => {
    return [
    'infinite', `/api/account-mappings/product-properties/${glNo}`
    ] as const;
    }

export const getGetAllAccountMappingsByProductPropertiesGlNoQueryKey = (glNo?: string,) => {
    return [
    `/api/account-mappings/product-properties/${glNo}`
    ] as const;
    }

    
export const getGetAllAccountMappingsByProductPropertiesGlNoInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getAllAccountMappingsByProductPropertiesGlNo>>>, TError = unknown>(glNo: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllAccountMappingsByProductPropertiesGlNo>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllAccountMappingsByProductPropertiesGlNoInfiniteQueryKey(glNo);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllAccountMappingsByProductPropertiesGlNo>>> = ({ signal }) => getAllAccountMappingsByProductPropertiesGlNo(glNo, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(glNo), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllAccountMappingsByProductPropertiesGlNo>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAllAccountMappingsByProductPropertiesGlNoInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getAllAccountMappingsByProductPropertiesGlNo>>>
export type GetAllAccountMappingsByProductPropertiesGlNoInfiniteQueryError = unknown


export function useGetAllAccountMappingsByProductPropertiesGlNoInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllAccountMappingsByProductPropertiesGlNo>>>, TError = unknown>(
 glNo: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllAccountMappingsByProductPropertiesGlNo>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllAccountMappingsByProductPropertiesGlNo>>,
          TError,
          Awaited<ReturnType<typeof getAllAccountMappingsByProductPropertiesGlNo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllAccountMappingsByProductPropertiesGlNoInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllAccountMappingsByProductPropertiesGlNo>>>, TError = unknown>(
 glNo: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllAccountMappingsByProductPropertiesGlNo>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllAccountMappingsByProductPropertiesGlNo>>,
          TError,
          Awaited<ReturnType<typeof getAllAccountMappingsByProductPropertiesGlNo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllAccountMappingsByProductPropertiesGlNoInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllAccountMappingsByProductPropertiesGlNo>>>, TError = unknown>(
 glNo: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllAccountMappingsByProductPropertiesGlNo>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAllAccountMappingsByProductPropertiesGlNoInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllAccountMappingsByProductPropertiesGlNo>>>, TError = unknown>(
 glNo: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllAccountMappingsByProductPropertiesGlNo>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAllAccountMappingsByProductPropertiesGlNoInfiniteQueryOptions(glNo,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetAllAccountMappingsByProductPropertiesGlNoQueryOptions = <TData = Awaited<ReturnType<typeof getAllAccountMappingsByProductPropertiesGlNo>>, TError = unknown>(glNo: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllAccountMappingsByProductPropertiesGlNo>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllAccountMappingsByProductPropertiesGlNoQueryKey(glNo);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllAccountMappingsByProductPropertiesGlNo>>> = ({ signal }) => getAllAccountMappingsByProductPropertiesGlNo(glNo, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(glNo), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllAccountMappingsByProductPropertiesGlNo>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAllAccountMappingsByProductPropertiesGlNoQueryResult = NonNullable<Awaited<ReturnType<typeof getAllAccountMappingsByProductPropertiesGlNo>>>
export type GetAllAccountMappingsByProductPropertiesGlNoQueryError = unknown


export function useGetAllAccountMappingsByProductPropertiesGlNo<TData = Awaited<ReturnType<typeof getAllAccountMappingsByProductPropertiesGlNo>>, TError = unknown>(
 glNo: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllAccountMappingsByProductPropertiesGlNo>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllAccountMappingsByProductPropertiesGlNo>>,
          TError,
          Awaited<ReturnType<typeof getAllAccountMappingsByProductPropertiesGlNo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllAccountMappingsByProductPropertiesGlNo<TData = Awaited<ReturnType<typeof getAllAccountMappingsByProductPropertiesGlNo>>, TError = unknown>(
 glNo: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllAccountMappingsByProductPropertiesGlNo>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllAccountMappingsByProductPropertiesGlNo>>,
          TError,
          Awaited<ReturnType<typeof getAllAccountMappingsByProductPropertiesGlNo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllAccountMappingsByProductPropertiesGlNo<TData = Awaited<ReturnType<typeof getAllAccountMappingsByProductPropertiesGlNo>>, TError = unknown>(
 glNo: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllAccountMappingsByProductPropertiesGlNo>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAllAccountMappingsByProductPropertiesGlNo<TData = Awaited<ReturnType<typeof getAllAccountMappingsByProductPropertiesGlNo>>, TError = unknown>(
 glNo: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllAccountMappingsByProductPropertiesGlNo>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAllAccountMappingsByProductPropertiesGlNoQueryOptions(glNo,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getAccountMappingByProductPropertiesGlNoAndMappingType = (
    glNo: string,
    mappingType: AccountMappingType,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<AccountMappingDTO>(
      {url: `/api/account-mappings/product-properties/${glNo}/mapping-type/${mappingType}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetAccountMappingByProductPropertiesGlNoAndMappingTypeInfiniteQueryKey = (glNo?: string,
    mappingType?: AccountMappingType,) => {
    return [
    'infinite', `/api/account-mappings/product-properties/${glNo}/mapping-type/${mappingType}`
    ] as const;
    }

export const getGetAccountMappingByProductPropertiesGlNoAndMappingTypeQueryKey = (glNo?: string,
    mappingType?: AccountMappingType,) => {
    return [
    `/api/account-mappings/product-properties/${glNo}/mapping-type/${mappingType}`
    ] as const;
    }

    
export const getGetAccountMappingByProductPropertiesGlNoAndMappingTypeInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getAccountMappingByProductPropertiesGlNoAndMappingType>>>, TError = unknown>(glNo: string,
    mappingType: AccountMappingType, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAccountMappingByProductPropertiesGlNoAndMappingType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAccountMappingByProductPropertiesGlNoAndMappingTypeInfiniteQueryKey(glNo,mappingType);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccountMappingByProductPropertiesGlNoAndMappingType>>> = ({ signal }) => getAccountMappingByProductPropertiesGlNoAndMappingType(glNo,mappingType, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(glNo && mappingType), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAccountMappingByProductPropertiesGlNoAndMappingType>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAccountMappingByProductPropertiesGlNoAndMappingTypeInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getAccountMappingByProductPropertiesGlNoAndMappingType>>>
export type GetAccountMappingByProductPropertiesGlNoAndMappingTypeInfiniteQueryError = unknown


export function useGetAccountMappingByProductPropertiesGlNoAndMappingTypeInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAccountMappingByProductPropertiesGlNoAndMappingType>>>, TError = unknown>(
 glNo: string,
    mappingType: AccountMappingType, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAccountMappingByProductPropertiesGlNoAndMappingType>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccountMappingByProductPropertiesGlNoAndMappingType>>,
          TError,
          Awaited<ReturnType<typeof getAccountMappingByProductPropertiesGlNoAndMappingType>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAccountMappingByProductPropertiesGlNoAndMappingTypeInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAccountMappingByProductPropertiesGlNoAndMappingType>>>, TError = unknown>(
 glNo: string,
    mappingType: AccountMappingType, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAccountMappingByProductPropertiesGlNoAndMappingType>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccountMappingByProductPropertiesGlNoAndMappingType>>,
          TError,
          Awaited<ReturnType<typeof getAccountMappingByProductPropertiesGlNoAndMappingType>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAccountMappingByProductPropertiesGlNoAndMappingTypeInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAccountMappingByProductPropertiesGlNoAndMappingType>>>, TError = unknown>(
 glNo: string,
    mappingType: AccountMappingType, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAccountMappingByProductPropertiesGlNoAndMappingType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAccountMappingByProductPropertiesGlNoAndMappingTypeInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAccountMappingByProductPropertiesGlNoAndMappingType>>>, TError = unknown>(
 glNo: string,
    mappingType: AccountMappingType, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAccountMappingByProductPropertiesGlNoAndMappingType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAccountMappingByProductPropertiesGlNoAndMappingTypeInfiniteQueryOptions(glNo,mappingType,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetAccountMappingByProductPropertiesGlNoAndMappingTypeQueryOptions = <TData = Awaited<ReturnType<typeof getAccountMappingByProductPropertiesGlNoAndMappingType>>, TError = unknown>(glNo: string,
    mappingType: AccountMappingType, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountMappingByProductPropertiesGlNoAndMappingType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAccountMappingByProductPropertiesGlNoAndMappingTypeQueryKey(glNo,mappingType);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccountMappingByProductPropertiesGlNoAndMappingType>>> = ({ signal }) => getAccountMappingByProductPropertiesGlNoAndMappingType(glNo,mappingType, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(glNo && mappingType), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAccountMappingByProductPropertiesGlNoAndMappingType>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAccountMappingByProductPropertiesGlNoAndMappingTypeQueryResult = NonNullable<Awaited<ReturnType<typeof getAccountMappingByProductPropertiesGlNoAndMappingType>>>
export type GetAccountMappingByProductPropertiesGlNoAndMappingTypeQueryError = unknown


export function useGetAccountMappingByProductPropertiesGlNoAndMappingType<TData = Awaited<ReturnType<typeof getAccountMappingByProductPropertiesGlNoAndMappingType>>, TError = unknown>(
 glNo: string,
    mappingType: AccountMappingType, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountMappingByProductPropertiesGlNoAndMappingType>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccountMappingByProductPropertiesGlNoAndMappingType>>,
          TError,
          Awaited<ReturnType<typeof getAccountMappingByProductPropertiesGlNoAndMappingType>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAccountMappingByProductPropertiesGlNoAndMappingType<TData = Awaited<ReturnType<typeof getAccountMappingByProductPropertiesGlNoAndMappingType>>, TError = unknown>(
 glNo: string,
    mappingType: AccountMappingType, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountMappingByProductPropertiesGlNoAndMappingType>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccountMappingByProductPropertiesGlNoAndMappingType>>,
          TError,
          Awaited<ReturnType<typeof getAccountMappingByProductPropertiesGlNoAndMappingType>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAccountMappingByProductPropertiesGlNoAndMappingType<TData = Awaited<ReturnType<typeof getAccountMappingByProductPropertiesGlNoAndMappingType>>, TError = unknown>(
 glNo: string,
    mappingType: AccountMappingType, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountMappingByProductPropertiesGlNoAndMappingType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAccountMappingByProductPropertiesGlNoAndMappingType<TData = Awaited<ReturnType<typeof getAccountMappingByProductPropertiesGlNoAndMappingType>>, TError = unknown>(
 glNo: string,
    mappingType: AccountMappingType, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountMappingByProductPropertiesGlNoAndMappingType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAccountMappingByProductPropertiesGlNoAndMappingTypeQueryOptions(glNo,mappingType,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




